import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Socials from "./Socials";

gsap.registerPlugin(ScrollTrigger);

function Hero() {
  const containerRef = useRef(null);
  const neonOverlayRef = useRef(null);
  const maskContainerRef = useRef(null);
  const svgRef = useRef(null);

  useEffect(() => {
    gsap.to(neonOverlayRef.current, {
      width: "100%",
      scrollTrigger: {
        trigger: containerRef.current,
        start: "top top",
        end: "+=150",
        scrub: true,
        markers: false
      }
    });

    gsap.to(svgRef.current, {
      fill: "#D0F034",
      scrollTrigger: {
        trigger: containerRef.current,
        start: "top top",
        end: "+=500",
        scrub: true,
        markers: false
      }
    });
  }, []);

  return (
    <div ref={containerRef} className="hero-container">
      <Socials />
      <section className="image-wrapper">
        <figure>
          <img
            src="/images/hero-farzad.png"
            alt="Portrait of Farzad Cheshk, consultant, entrepreneur, and speaker"
            className="hero-image"
            loading="lazy"
          />
          <figcaption>Farzad Cheshk, a prominent consultant and entrepreneur</figcaption>
        </figure>
      </section>
      <div ref={maskContainerRef} className="mask-container" aria-hidden="true">
        <div ref={neonOverlayRef} className="neon-overlay"></div>
      </div>
    </div>
  );
}

export default Hero;
